import * as React from 'react';

import { useDispatch } from 'react-redux'
import { setOperation } from '../operation/operationSlice';

import DataList from '../../components/controls/datagrid/DataList';
import DataColumn from '../../components/controls/datagrid/DataColumn';

export default (props: { controller: string, items: any }) => {
    const dispatch = useDispatch()
    const onRowClick = (e: any, data: any) => {
        e.preventDefault()
        dispatch(setOperation("read", props.controller, { index: data }))
    }

    return (
        <>
            <DataList items={props.items} onRowClick={onRowClick}>
                <DataColumn kid='column1' name='Nome' fieldName='name' minWidth={280} align='left' />
                <DataColumn kid='column2' name='Gruppo' fieldName='group_type' minWidth={280} align='left' />
            </DataList>
        </>
    );
}